export default {
  state: {
    embedPageUrl: null,
    isEmbedPageOpened: false,
  },
  mutations: {
    OPEN_EMBED_PAGE(state, embedUrl) {
      state.embedPageUrl = embedUrl;
      state.isEmbedPageOpened = true;
    },
    CLOSE_EMBED_PAGE(state) {
      state.isEmbedPageOpened = false;
      setTimeout(() => {
        state.embedPageUrl = null;
      }, 500);
    },
  },
  actions: {
    openInstructionVideo({ commit }, videoLink) {
      commit('OPEN_EMBED_PAGE', videoLink);
    },
    openEmbedPage({ commit }, embedUrl) {
      commit('OPEN_EMBED_PAGE', embedUrl);
    },
    closeEmbedPage({ commit }) {
      commit('CLOSE_EMBED_PAGE');
    },
  },
  getters: {
    embedPageUrl(state) {
      return state.embedPageUrl;
    },
    isEmbedPageOpened(state) {
      return state.isEmbedPageOpened;
    },
  },
};
